module.exports = __webpack_public_path__ + "static/media/Logo.283003ea.png";